import { CustomerEmailEntity } from '../entities/email-entity';

export default class State {
  items: Array<CustomerEmailEntity> = [];
}
